module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/envelope-a6733a561ebbed0a64d61f2b867e7559.svg&quot;;"